<!-- 发票页面 -->
<template>
    <div class="sld_my_balance">
        <MemberTitle :memberTitle="'发票'"></MemberTitle>

        <!-- 内容 -->
        <div class="bill_content">
            <div class="bill_detail">
                <div class="detail_item">
                    <div class="tit">可开票金额</div>
                    <div class="next">
                        <div class="price_detail">
                            <text>￥</text>
                            <text>{{ Number(invoiceAmount).toFixed(2).split('.')[0] }}</text>
                            <text>.{{ Number(invoiceAmount).toFixed(2).split('.')[1] }}</text>
                        </div>
                        <div class="btn" @click="applyBill">申请开票</div>
                    </div>
                </div>
                <div class="detail_item">
                    <div class="tit">
                        <text>已开票金额</text>
                    </div>
                    <div class="next">
                        <div class="price_detail">
                            <text>￥</text>
                            <text>{{ Number(alreadyAmount).toFixed(2).split('.')[0] }}</text>
                            <text>.{{Number(alreadyAmount).toFixed(2).split('.')[1] }}</text>
                        </div>
                    </div>
                </div>
                <div class="detail_item">
                    <div class="tit">
                        <text>发票抬头</text>
                        <text class="manage" @click="addBill" v-if="!invoiceInfo">添加</text>
                    </div>

                    <div class="next next_name">
                        {{ invoiceInfo == '' ? '--' : invoiceInfo }}
                    </div>
                </div>
                <div class="detail_item">
                    <div class="tit">
                        <text>电子邮箱</text>
                        <text class="manage" @click="goEmail">管理</text>
                    </div>
                    <div class="next">
                        <text class="icon" v-if="DefaultEmail">默认</text>
                        <text class="email next_name">{{ GetPageEmail ? GetPageEmail : '暂无邮箱' }}</text>
                    </div>
                </div>
            </div>

            <!-- 开票记录 -->
            <div class="invoicingRecord">
                <div class="notes">开票记录</div>
                <div v-if="currentTabIndex == 0" class="table">
                    <el-table :data="orderList.data" style="width: 100%;"
                        :header-cell-style="{ 'text-align': 'center', 'background': '#fafafa' }"
                        :cell-style="{ 'text-align': 'center' }" empty-text="暂无数据">
                        <el-table-column prop="invoiceTime" label="开票时间" width="174" />
                        <el-table-column prop="orderAmount" label="开票金额" width="113" />
                        <el-table-column prop="invoiceSn" label="开票号" width="131" />
                        <el-table-column prop="invoiceType" label="开票类型" width="133" >
                            <template #default="scope">
                                <text>{{ scope.row.invoiceType == 1 ? '增值税普通发票' : '增值税专用发票' }}</text>
                            </template>
                        </el-table-column>
                        <el-table-column prop="invoiceTitle" label="发票抬头" width="157" />
                        <el-table-column prop="invoiceSubject" label="开票主体" width="151" />
                        <el-table-column prop="orderSn" label="订单号" width="131" />
                        <el-table-column prop="" label="操作" width="114">
                            <template #default="scope">
                                <text class="payFor" @click="downloadItem(scope.row)">下载</text>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>


            <!-- 分页 -->
            <div class="pageTo">
                <el-pagination background layout="prev, pager, next" :total="paginationList.total"
                    v-model:currentPage="paginationList.current" @current-change="handleCurrentChange" />
            </div>


        <!-- 添加发票抬头 start -->
		<el-dialog title="添加发票抬头" class="el_dialog_bill" v-model="InvoiceFlag" width="510px" lock-scroll="false" top="10%"
			:before-close="closeBtn">
			<div class="Invoice_item flex">
				<div class="title"><i>*</i>发票类型：</div>
				<div class="right_info flex_column_center_start">
					<div class="item_select flex">
						<div @click="changeInvoiceTypes(2)" :class="{
							select_btn: true,
							pointer: true,
							active: invoiceType == 2,
						}">
							增值税专用发票
						</div>
						<div @click="changeInvoiceTypes(1)" :class="{
							select_btn: true,
							pointer: true,
							active: invoiceType == 1,
						}">
							增值税普通发票
						</div>
					</div>
					<!-- <el-input class="input" size="small" placeholder="请在此填写发票抬头" v-model="input" clearable></el-input> -->
				</div>
			</div>
			<div class="Invoice_item flex">
				<div class="title"><i>*</i>抬头类型：</div>
				<div class="right_info flex_column_center_start">
					<div class="item_select flex">
						<div :class="{
							select_btn: true,
							pointer: true,
							active: true,
						}">
							企业
						</div>
					</div>
				</div>
			</div>
			<div class="Invoice_item flex">
				<div class="title"><i>*</i>单位全称：</div>
				<input v-model="invoiceTitle" disabled type="text" class="Invoice_unit" placeholder="请输入单位全称">
				<!-- <div class="content">上海市某某科技有限公司</div> -->
			</div>
			<div class="Invoice_item flex">
				<div class="title"><i>*</i>税号：</div>
				<input type="text" v-model="taxCode" placeholder="请输入税号" class="Invoice_item_input">
			</div>

            <div class="Invoice_item flex" v-if="invoiceType == 2">
				<div class="title"><i>*</i>开票地址：</div>
				<input type="text" v-model="registerAddr" placeholder="请输入开票地址" class="Invoice_item_input">
			</div>

            <div class="Invoice_item flex" v-if="invoiceType == 2">
				<div class="title"><i>*</i>开票电话：</div>
				<input type="text" v-model="registerPhone" placeholder="请输入开票电话" class="Invoice_item_input">
			</div>

            <div class="Invoice_item flex" v-if="invoiceType == 2">
				<div class="title"><i>*</i>开户行：</div>
				<input type="text" v-model="bankName" placeholder="请输入开户行" class="Invoice_item_input">
			</div>

             <div class="Invoice_item flex" v-if="invoiceType == 2">
				<div class="title"> <i>*</i>银行账户：</div>
				<input type="text" v-model="bankAccount" placeholder="请输入银行账户" class="Invoice_item_input">
			</div>

			<template #footer>
				<span class="dialog-footer">
					<el-button class="el_btn_close" size="small" @click="closeBtn">取消</el-button>
					<el-button class="el_btn_sub" size="small" @click="submitInvoice">
						确定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 添加发票抬头 end -->
        </div>

    </div>
</template>
  
<script>
import { ref, reactive, getCurrentInstance, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import MemberTitle from '../../../components/MemberTitle';
import { ElMessage } from "element-plus";
export default {
    name: "Balance",
    components: {
        MemberTitle,
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const router = useRouter()
        const currentTabIndex = ref(0)
        const tabList = reactive(['信用账单', '额度明细', '额度记录'])
        const invoiceType = ref(2);//发票类型
        const InvoiceFlag = ref(false);//添加发票抬头
        const emailFlag = ref(false);//添加电子邮箱
        const invoiceInfo = ref('')
        const invoiceTitle = ref('') //发票单位全称
        
        const taxCode = ref('') //社会统一信用编码
        const registerAddr = ref('') //开票地址
        const registerPhone = ref('') // 开票电话
        const bankName = ref('') // 开户行
        const bankAccount = ref('') // 银行账户

        const getInvoiceId = ref('') //发票id
        const GetPageEmail = ref('') //邮箱
        const DefaultEmail = ref(false) //是否是默认邮箱
        const invoiceAmount = ref('') //可开票金额
        const alreadyAmount = ref('') //可开票金额
        const paginationList = reactive({
            pageSize: 10,
            current: 1,
            total: 0
        })
        const orderList = reactive({ //已开票列表
            data: []
        })
        // 申请开票
        const applyBill = () => router.push('/member/applyBill')

        // 添加发票
        const addBill = () => {
            InvoiceFlag.value = true
            let memberInfo = JSON.parse(localStorage.getItem('memberInfo'))
            invoiceTitle.value = memberInfo.companyName
        }
        //切换发票类型
        const changeInvoiceTypes = (type) => {
            invoiceType.value = type
        }
        // 获取发票列表
        const GetOrderList = () => {
            let param = {}
            param.pageSize = paginationList.pageSize
            param.current = paginationList.current
            param.invoiceStatus = 1
            proxy.$get('v3/business/front/openInvoice/list', param).then((res) => {
                if (res.state == 200) {
                    orderList.data = res.data.list
                    paginationList.total = res.data.pagination.total
                }
                // console.log(res)
            })
        }

        // 获取发票信息
        const getInvoice = () => {
            proxy.$get('v3/member/front/memberInvoice/detail').then(res => {
                if (res.state != 200) {
                    invoiceInfo.value = ''
                } else {
                    invoiceInfo.value = res.data.invoiceTitle
                    getInvoiceId.value = res.data.invoiceId
                }
            })
        }
        const goEmail = () => router.push('/member/chooseemail')

        const closeBtn = () => {
            InvoiceFlag.value = false
            invoiceType.value = 2
            invoiceTitle.value = ''
            taxCode.value = ''
        }

        // 提交发票信息
		const submitInvoice = () => {
			const param = {
				invoiceType: invoiceType.value,
				titleType: 2,
				invoiceTitle: invoiceTitle.value,
                taxCode: taxCode.value,
            }
            if(!param.taxCode){
                ElMessage.error('请输入税号')
                return;
            }
            if(invoiceType.value==2){
                param.registerAddr = registerAddr.value;
                param.registerPhone = registerPhone.value;
                param.bankName = bankName.value;
                param.bankAccount = bankAccount.value;
                if(!param.registerAddr){
                ElMessage.error('请输入开票地址')
                return;
                }
                if(!param.registerPhone){
                    ElMessage.error('请输入开票电话')
                    return;
                }
                if(!param.bankName){
                    ElMessage.error('请输入开户行')
                    return;
                }
                if(!param.bankAccount){
                    ElMessage.error('请输入银行账户')
                    return;
                }
            }
            
			proxy.$post('v3/member/front/memberInvoice/add', param).then(res => {
				if (res.state == 200) {
					ElMessage.success({
						message: res.msg,
						type: "success"
					});
					getInvoice()
					InvoiceFlag.value = false
					// 清空信息
					invoiceType.value = 2
					invoiceTitle.value = ''
					taxCode.value = ''
				} else {
					ElMessage.error(res.msg)
				}
			})
		}
        //页数改变
        const handleCurrentChange = current => {
            paginationList.current = current;
            GetOrderList()

        };

        // 获取邮箱列表
        const getEmail = () => {
            let param = {};
            param.current = '';
            param.pageSize = '';
            proxy.$get("v3/member/front/memberEmail/list", param).then((res) => {
                if (res.state == 200) {
                    console.log(res, '200')
                    let isTrue = false
                    res.data.list.map(item => {
                        if (item.isDefault == 1) {
                            GetPageEmail.value = item.email
                            DefaultEmail.value = true
                            isTrue = true
                        }
                    })
                    if (isTrue == false) {
                        GetPageEmail.value = res.data.list[0].email
                        DefaultEmail.value = false
                    }
                }
            });
        }

        // 获取开票金额
        const getvAmount = (type) => {
            proxy.$get('v3/business/front/openInvoice/amount',{invoiceStatus: type}).then(res => {
                if (type == 0) {
                    invoiceAmount.value = res.data
                } else {
                    alreadyAmount.value = res.data
                }
                
            })
        }

        // 下载发票
        const downloadItem = (item) => {
            if (item.invoiceUrl) {
                window.location.href = item.invoiceUrl
            } else {
                // ElMessage.error('当前URL为空')
                 proxy.$get('v3/business/front/openInvoice/invoiceUrl',{orderSn: item.orderSn}).then(res => {
                if (res.state == 200) {
                    window.location.href = res.msg
                } else {
                    ElMessage.error(res.msg)
                }
                
            })
            }
            
        }
        onMounted(() => {
            getInvoice()

            getEmail()
            GetOrderList()
            // 调两次获取开票接口 0 未开 1 已开
            getvAmount(0)
            getvAmount(1)
        })
        return {
            currentTabIndex,
            tabList,
            invoiceType,
            emailFlag,
            InvoiceFlag,
            invoiceInfo,
            getInvoiceId,
            invoiceTitle,
            taxCode,
            GetPageEmail,
            DefaultEmail,
            paginationList,
            orderList,
            invoiceAmount,
            alreadyAmount,

            registerAddr,
            registerPhone,
            bankName,
            bankAccount,

            // 方法
            applyBill,
            addBill,
            changeInvoiceTypes,
            goEmail,
            getInvoice,
            submitInvoice,
            closeBtn,
            getEmail,
            GetOrderList,
            handleCurrentChange,
            downloadItem,
            getvAmount,
        };
    }
};
</script>
  
<style lang="scss" scoped>
@import "../../../style/member/bill.scss";
</style>